import React, { useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";
import {
  useParams,
  useLocation,
  useNavigate,
  useNavigationType,
} from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailPageScroll,
  fetchVoucherInfo,
  updateVoucherInfo,
  updateVoucherInfoList,
} from "redux/slices/sales/salesSlice";

import { getDetailTitle } from "utils/define";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import DetailList from "./DetailList";
import PullToRefreshing from "components/common/PullToRefreshing";

/**
 * [이용권 종류별 매출]
 */

export const Detail = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigationType = useNavigationType();
  const { seqPartnerBranch } = useParams();

  let {
    searchPartner,
    searchBranch,
    searchDate,
    searchPeriodType,
    searchFilter,
    data,
    isLoading,
    isError,
  } = useSelector((state) => state.sales.voucherInfo);
  const partnerInfo = useSelector((state) => state.partner);
  const salesInfo = useSelector((state) => state.sales);

  useEffect(() => {
    if (
      !searchPartner ||
      (navigationType != "POP" &&
        (searchPartner != partnerInfo.seqPartner ||
          searchBranch != partnerInfo.seqPartnerBranch ||
          searchPeriodType != salesInfo.searchPeriodType))
    ) {
      searchPartner = partnerInfo.seqPartner;
      searchBranch = Number(seqPartnerBranch) || partnerInfo.seqPartnerBranch;
      searchDate = salesInfo.searchDate;
      searchPeriodType = salesInfo.searchPeriodType;
      dispatch(
        fetchVoucherInfo({
          searchPartner: searchPartner,
          searchBranch: searchBranch,
          searchDate: searchDate,
          searchPeriodType: searchPeriodType,
        })
      );
    }
  }, []);

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchDetailPageScroll("store"));
    };
  }, []);

  useEffect(() => {
    const isUpdate =
      !data ||
      navigationType != "POP" ||
      searchPartner != data.searchInfo.searchPartner ||
      searchBranch != data.searchInfo.searchBranch ||
      searchDate != data.searchInfo.searchDate ||
      searchPeriodType != data.searchInfo.searchPeriodType ||
      searchFilter != data.searchInfo.searchFilter;
    if (isUpdate) {
      if (!isLoading) {
        eventHandler.update();
      }
    }
  }, [searchPartner, searchBranch, searchDate, searchPeriodType, searchFilter]);

  const eventHandler = {
    update: () => {
      dispatch(
        updateVoucherInfo(
          {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: searchPeriodType,
            searchFilter: searchFilter,
          },
          fetchVoucherInfo,
          "voucherInfo"
        )
      );
    },
    changeDate: (date) => {
      dispatch(
        fetchVoucherInfo({
          searchDate: date,
        })
      );
    },
    pullToRefresh: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          eventHandler.update();
          dispatch(updateVoucherInfoList(false));
          resolve();
        }, 700);
      });
    },
  };

  const render = () => {
    const title = getDetailTitle(
      partnerInfo,
      searchPartner,
      searchBranch,
      "이용권 종류별 매출"
    );
    return (
      <PullToRefresh
        onRefresh={eventHandler.pullToRefresh}
        resistance={2}
        pullingContent={<></>}
        refreshingContent={<PullToRefreshing />}
      >
        <MainLayout
          withHeader={true}
          headerProps={{
            withBackButton: true,
            centerTitle: title,
          }}
          backgroundColor="white"
          withBottomTab={false}
        >
          <SummaryInfo
            mode={searchPeriodType}
            date={searchDate}
            data={data}
            isLoading={isLoading}
            isError={isError}
            onChange={eventHandler.changeDate}
            onRefresh={eventHandler.update}
          />
          <DetailList />
        </MainLayout>
      </PullToRefresh>
    );
  };

  return render();
};

export default Detail;
